export default "__VITE_PUBLIC_ASSET__ce6f6a18__"